<template>
    <modal-wrapper modalClass="modal--form" :modalName="name">
        <form class="form">
            <div class="modal__header">
                <h1>Styleguide form modal</h1>
            </div>
            <div class="modal__content">
                <div class="form__item">
                    <i class="form__icon icons icon-location-pin"></i>
                    <div class="form__select">
                        <select class="form__input--select">
                            <option>Pick a location...</option>
                            <option>Choice 1</option>
                            <option>Option 2</option>
                        </select>
                    </div>
                </div>

                <h2>Extra header</h2>
                <div class="form__item">
                    <i class="form__icon icons icon-location-pin"></i>
                    <div class="form__select">
                        <select class="form__input--select">
                            <option>Pick a location...</option>
                            <option>Choice 1</option>
                            <option>Option 2</option>
                        </select>
                    </div>
                </div>

                <h2>Another header</h2>

                <div class="form__item">
                    <label class="form__label">Please enter your E-Mailaddress</label>
                    <i class="form__icon icons icon-envelope"></i>
                    <input class="form__input--text" type="email" id="email" />
                </div>

                <div class="form__item">
                    <label class="form__label">Please enter your password</label>
                    <i class="form__icon icons icon-lock"></i>
                    <input class="form__input--text" type="password" id="password"/>
                </div>
                <div class="form__item">
                    <label class="form__label">This is a nice input field for a longer description.</label>
                    <i class="form__icon icons icon-pencil"></i>
                    <textarea class="form__input--textarea--dynamic" placeholder="Start typing here..."></textarea>
                </div>

            </div>
            <div class="modal__footer">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit">Add / Save</button>
                    <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">Cancel</button>
                </div>
            </div>
        </form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import ModalWrapper from '@/components/general/ModalWrapper';

    @Component
    export default class StyleguideModal extends Vue {
        name = 'styleguide-modal';
        selected1 = null;
        selected2 = null;
        selected3 = null;
        selected4 = null;

    }

    Vue.component('styleguide-modal', StyleguideModal);
</script>



// WEBPACK FOOTER //
// src/components/modals/styleguide/StyleguideModal.vue